import { Theme } from "src/app/interfaces/theme.model";
const tunisiaDefaults = { promoImg: "url(assets/images/promo_3.png)" };

export const TunisiaTheme: Theme = {
  name: "tunisia",
  useGateway: true,
  showTcktVerification: false,
  properties: {
    //-------------------------  header-----------------------------
    "--app-background-base": "#fff",
    "--app-background-header": "#fff",
    "--app-background-body": "#e6e6e6",
    "--app-background-turf-home": "#e6e6e6",
    "--app-background-footer": "#bbbaba",
    "--app-background-left-menu": "#037b3a",
    "--app-background-right-menu": "",
    "--app-background-nav": "#E61780",
    "--app-background-nav-hover": "#ff05a7c4",
    "--app-background-nav-border-bottom": "#d40c71",
    "--app-background-main": "rgb(242, 242, 242)",
    "--app-background-home": "#037b3a",
    "--app-color-tournament": "#154e2b",
    "--app-color-heading": "#77777a",
    "--app-color-header": "#77777a",
    "--app-color-body": "#5d5d5d",
    "--app-color-footer": "#9ACC09",
    "--app-color-nav": "#fff",
    "--app-color-main": "#212121",
    "--app-color-forgot_pw": "#E61780",
    "--app-background-primary-tint": "",
    "--app-background-input-primary": "#dedede",
    "--app-background-secondary-tint": "#E61780",

    //-------------------------  owl calendar-----------------------------
    "--app-background-calendar-header": "#7fc31c",
    //-------------------------  side menu-----------------------------
    "--app-background-side-menu": "#e6e6e6",
    "--app-color-side-menu": "#fff",
    // lexique
    "--app-color-lexique": "#fff",
    "--app-background-lexique": "linear-gradient(to right, #588a11, #7fc41c)",
    "--app-background-cmtJr": "linear-gradient(to right, #588a11, #7fc41c)",
    "--app-color-cmtJr": "#fff",

    // promotions
    "--app-color-promotions": "#fff",
    "--app-background-promotions":
      "linear-gradient(to right, #588a11, #7fc41c )",
    "--app-background-border-promotions":
      "linear-gradient(to right, #588a11, #7fc41c)",

    // cagnottes
    "--app-color-cagnotte-header": "#fff",
    "--app-background-cagnotte-header": "#5d5d5d",
    //-------------------------  second nav-----------------------------
    "--app-background-second-nav": "#E61780",
    "--app-background-second-nav-hover": "#E61780",
    "--app-color-second-nav": "#fff",
    "--app-background-second-nav-selected": "#fff",
    "--app-color-second-nav-selected": "#E61780",
    "--app-background-border-second-nav-selected": "#E61780",
    "--app-color-second-nav-course": "#77777a",

    //-------------------------  rapports-----------------------------
    "--app-color-rapport": "#e61780",
    "--app-background-rapport": "#E61780",
    "--app-background-rapport-header-border": "#9ACC09",

    //-------------------------  top races-----------------------------
    "--app-color-top-race-RN": "#5d5d5d",
    "--app-color-top-race-CN": "#5d5d5d",
    "--app-color-top-race-time": "#bbbbbb",
    "--app-color-top-race-time-up": "#5d5d5d",
    // "--app-background-top-race":"linear-gradient(0deg, #a20957, #e61780)",
    "--app-background-top-race": "#fff",

    //-------------------------  meetings-----------------------------
    "--app-color-meeting-link": "#8e8d8d",
    "--app-background-meeting-link": "#e6e6e6",
    "--app-color-meeting-link-selected": "#E61780",
    "--app-background-meeting-link-selected": "#ffff",
    "--app-background-meeting-link-borders": "#fa7f22",

    //-------------------------  race details-----------------------------
    "--app-color-race-time": "#5d5d5d",
    //-------------------------  race list-----------------------------
    "--app-color-table-header": "",
    "--app-color-table-header-border-left": "#dad8d8",
    "--app-color-table-headings": "",
    "--app-color-table": "#5d5d5d",
    "--app-color-table-subdetails": "#5d5d5d",
    "--app-color-table-numbers": "#5d5d5d",
    "--app-color-table-open": "#fff",
    "--app-color-table-content-open": "#5d5d5d",
    "--app-background-table-open": "#E61780",
    "--app-background-wrap-race": "#fff",
    //-------------------------  race details-----------------------------
    "--app-color-registration": "#5d5d5d",
    "--app-background-registration": "#bbbaba",
    "--app-background-registration-input": "#dedede",
    "--app-color-registration-input": "#000",
    "--app-background-registration-input-border": "#969292",
    "--app-color-registration-validation-error": "#E61780",

    //-------------------------  footer-----------------------------
    "--app-background-footer-pages": "#e6e6e6",
    // reset password
    "--app-color-resetpw-header": "#bbbaba",
    //-------------------------  transactions history and account -----------------------------
    "--app-background-transactions": "#fff",
    "--app-background-profile-body": "#bbbaba",
    "--app-background-profile-header": "#E61780",
    "--app-background-profile-header-border": "#fff",
    "--app-background-profile-section-header": "#E61780",
    "--app-color-profile-section-activeheader": "#fff",
    "--app-color-profile-section-header": "#fff",
    "--app-color-profile-input": "#5d5d5d",
    "--app-color-profile-input-placeholder": "#eee",
    "--app-background-profile-input": "#e6e6e6",
    "--app-color-profile-input-border": "#bbbaba",
    "--app-color-profile-input-lable": "#5d5d5d",
    "--app-background-transactions-body": "#bbbaba",
    "--app-color-transactions-header": "#5d5d5d",
    "--app-color-transactions-header-input-border": "#fff",
    "--app-color-transactions-header-input-lable": "#fff",
    "--app-color-transactions-header-input": "#fff",
    "--app-color-transaction-tab-secondary": "#628207",
    "--app-color-transaction-tab-primary": "#5d5d5d",
    "--app-background-transactions-tabs": "#bbbaba",
    "--app-color-accounts": "#5d5d5d",
    "--app-color-accounts-header": "#fff",
    "--app-color-accounts-item-border": "#77777a",
    "--app-color-accounts-item": "#5d5d5d",
    "--app-background-row-even": "#fff",
    "--app-background-row-odd": "#dedede",
    "--app-color-transactions-container-color": "#154e2b",
    "--app-background-transaction-methods": "#a1a1a2",
    "--app-background-active-trans-method":
      "linear-gradient(to right, #588a11, #7fc41c)",
    "--app-color-methods-border-left": "#a1a1a2",
    "--app-color-border-acc-input-focus": "#a1a1a2",

    //-------------------------  betslip-----------------------------
    "--app-color-betslip-header": "#fff",
    "--app-background-betslip-header": "#E61780",
    "--app-background-betSummary": "#9ACC09",
    "--app-color-betSummary": "#fff",
    "--app-color-yello-odd": "#9ACC09",
    "--app-color-background-dropdown": "#e61780",
    "--app-color-betslip": "#77777a",
    "--app-background-betslip": "#fff",
    "--app-color-betslip-amount": "#e61780",
    "--app-color-betslip-meeting": "#777777",
    //-------------------------  betslip-----------------------------
    "--app-background-checkbox-input-unchecked": "#ffffffa4",
    "--app-color-checkbox-input-border-unchecked": "#777676e5",

    "--app-background-checkbox-input": "#9ACC09",
    "--app-color-checkbox-input-border": "#fff",
    //-------------------------  account modal -----------------------------

    "--app-background-modal-window": "#77777a",
    "--app-color-modal-window": "#fff",

    //-------------------------  buttons-----------------------------
    "--app-color-button-primary": "#fff",
    "--app-background-button-primary": "#E61780",
    "--app-color-button-secondary": "#fff",
    "--app-color-button-secondary-border": "#E61780",
    "--app-background-button-secondary": "#E61780",
    "--app-color-button-secondary-invert": "#e61780",
    "--app-color-button-secondary-border-invert": "#e61780",
    "--app-background-button-secondary-invert": "#fff",
    "--app-color-bet-button": "#fff",
    "--app-background-bet-button": "#e61780",
    "--app-color-rapport-button": "#e61780",
    "--app-background-rapport-button-border": "#e61780",
    "--app-background-rapport-button": "#fff",
    "--app-color-betSlip-button": "#fff",
    "--app-background-betSlip-button": "#e61780",

    //-------------------------  Account Modal-----------------------------
    "--app-background-main-modal": "#E61780",
    "--app-color-main-modal": "#efd7c2",
    "--app-color-main-modal-border": "#176334",
    // ------------------------ footer -----------------------------------
    "--app-color-footer-heading-1": "#77777a",
    "--app-color-footer-body": "#5d5d5d",
    // ------------------------faq ---------------------------------------
    "--app-color-faq-header": "#5d5d5d",
    "--app-color-footer-icon": "#777",

    // ------------------------- default images
    "--img-default-promo": tunisiaDefaults.promoImg,
  },
  country: "TU",
  contact:{
    tel: '+225 07 07 07 18 89',
    email: 'hotline@lonaci.ci',
    fax: '+225 01 01 51 44 00',
    addresse: 'e'
  },
  whiteIcon: true,
    betOptions: {
    version: '4.3'
  }
};